<template lang="html">
  <v-flex class="d-flex flex-column justify-center mt-5 mb-4 mx-auto">
    <v-row class="justify-center mx-0">
      <v-col cols="6" sm="3" md="3" lg="3" xl="3" class="pb-0">
        <v-text-field
          v-model="amount_wise"
          :rules="only_digits"
          @input="calculateResult"
          solo
          dense
          elevation="2"
          class="simulatortextfield"
        ></v-text-field>
      </v-col>
      <v-col cols="6" sm="2" md="2" lg="2" xl="2" class="pb-0">
        <v-text-field
          value="WISE"
          solo
          dense
          readonly
          class="simulatortextfield"
        ></v-text-field>
      </v-col>

      <v-col cols="12" sm="1" md="1" lg="1" xl="1" class="text-center align-center pa-0 pt-1 ma-0">
        <v-icon x-large class="mt-2 ma-0 pa-0">mdi-swap-horizontal</v-icon>
      </v-col>
      <v-col cols="6" sm="3" md="3" lg="3" xl="3" class="pb-0">
        <v-text-field
          v-model="amount_result"
          :rules="only_digits"
          @input="calculateWise"
          solo
          dense
          class="simulatortextfield"
        ></v-text-field>

      </v-col>
      <v-col cols="6" sm="2" md="2" lg="2" xl="2" class="pb-0">
        <v-select
          return-object
          v-model="selected_result_coin"
          :items="result_coins"
          solo
          dense
        ></v-select>

      </v-col>
    </v-row>
  </v-flex>
</template>

<script>
import {
    mapState
  } from 'vuex';

  export default {
    name: "PriceWidget",
    data() {
      return {
        currentPriceUSD: 0,
        currentPriceETH: 0,
        only_digits: [v => {
          if (!isNaN(parseFloat(v)) && v >= 0) return true;
          return 'Only Numbers';
        }],
        amount_wise: 1,
        amount_result: 0,
        result_coins: [{
            text: "USD",
            value: 'usd'
          },
          {
            text: "ETH",
            value: 'eth'
          },
        ],
        selected_result_coin: {
          text: "USD",
          value: 'usd'
        },

      }
    },
    watch: {
      selected_result_coin: function() {
        this.calculateResult();
      },
      currentUniswapStats() {
        this.setPricesAndLiquidityAndRank();
      },
      currentETHPrice() {
        this.setPricesAndLiquidityAndRank();
      },
      totalSupply() {
        this.setPricesAndLiquidityAndRank();
      },
      totalStaked() {
        this.setPricesAndLiquidityAndRank();
      },
      uniswapBalance() {
        this.setPricesAndLiquidityAndRank();
      }
    },
    computed: {
      ...mapState({
        currentUniswapStats: state => state.currentUniswapStats,
        currentETHPrice: state => state.currentETHPrice,
        totalSupply: state => state.totalSupply,
        totalStaked: state => state.totalStaked,
        uniswapBalance: state => state.uniswapBalance,
      }),
    },
    mounted() {
      this.setPricesAndLiquidityAndRank();
    },
    methods: {
      isDataFetched() {
        return (
          this.$store.state.currentETHPrice > -1 &&
          this.$store.state.currentUniswapStats.priceETH > -1
        );
      },
      setPricesAndLiquidityAndRank() {
        if (this.isDataFetched()) {
          this.currentPriceETH = this.$store.state.currentUniswapStats.priceETH;
          this.currentPriceUSD = this.$store.state.currentETHPrice * this.$store.state.currentUniswapStats.priceETH;
          this.calculateResult();
        }
      },
      getPrice() {
        let price = this.currentPriceUSD;
        if (this.selected_result_coin.value === 'eth') {
          price = this.currentPriceETH;
        }
        return price;
      },
      calculateResult() {
        let price = this.getPrice();
        let result = this.amount_wise * price;
        this.amount_result = result.toFixed(6);
      },
      calculateWise() {
        let price = this.getPrice();
        let wise = this.amount_result / price;
        this.amount_wise = wise.toFixed(1);
      }
    }
  }
</script>

<style lang="css" scoped>
</style>
